export default {
  namespaced: true,
  state: {
    screenType: '',
    screenSize: {},
    villa: null,
    allBookingItemsSorted: [],
    usersBookings: null,
  },
  getters: {
    getScreenType: (state) => state.screenType,
    getScreenSize: (state) => state.screenSize,
    getVilla: (state) => state.villa,
    getBookingItems: (state) => state.allBookingItemsSorted,
    getVillaByID: (state) => (id) => state.allBookingItemsSorted.find((booking) => booking.propertyId === id),
    getUsersBookings: (state) => state.usersBookings,
  },
  mutations: {
    setScreenType(state, payload) {
      state.screenType = payload;
    },
    setScreenSize(state, payload) {
      state.screenSize = payload;
    },
    setVilla(state, payload) {
      state.villa = payload;
    },
    setBookingItems(state, payload) {
      state.allBookingItemsSorted = payload;
    },
    setVillaByID(state, commit, id) {
      const villa = state.allBookingItemsSorted.find((booking) => booking.propertyId === id);
      commit('setVillaID', villa);
    },
    setUsersBookings(state, payload) {
      state.usersBookings = payload;
    },
  },
};
